//import React from 'react';
import { Component as ReactComponent } from 'react';
import {PropTypes} from 'prop-types';
import {Link} from '../../shared/link';
import {SimpleTooltip} from '../../shared/tooltip';
import moment from 'moment-timezone';
import numeral from 'numeral';
import {MakeApiCall, WriteConsoleErrors, GetMomentTimeZoneName, ReplaceUrl} from '../../shared/utils';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';
import {EmailBlackListStatusComponent} from '../../shared/emailBlackListStatusComponent';
import {RefreshButtonComponent} from '../../shared/refreshButtonComponent';
import {LoadingIndicatorComponent} from '../../shared/loadingIndicatorComponent';
import {AccountComponent} from '../AccountsListComponent/account';
import {CreditCardCaptionComponent} from '../../shared/creditCardComponents';
import {Pagination} from '../../shared/Pagination';
import {InfoItem} from './infoitem';
import {DateTimeItem} from './datetimeitem';
import {UrlBuilder, INVOICE_STATE, PAYMENT_STATE, APPLICATION_TYPE} from '../../app.defs';
import {EditNotesDialogComponent} from '../../shared/EditNotesDialog';
import {PageHeader} from '../../shared/PageHeader';
import { ItemPopupDescriptionComponent } from '../../shared/itemPopupDescriptionComponent';
import { DurationComponent } from '../../components/job/durationComponent';

import './styles.scss';

const ACCOUNTINFO_ACTION = {
    NONE: 0,
    LOADING: 1,
    EDITNOTES: 2,
}

class DiscountScale1 extends ReactComponent {
    render() {
        const self = this;
        const scale = self.props.scale;

        if (!Boolean(scale)) {
            return null;
        }

        const volumes = scale.Items
            .map(p => p.MinVolume)
            .filter((p, i, a) => a.indexOf(p) == i);

        return (
            <SimpleTooltip
                isHtml
                title={
                    <div className="text-left">
                        {(scale.Items.length == 0) && <span className="text-secondary">empty</span>}
                        {(scale.Items.length > 0) && volumes
                            .map(volume => {
                                const discounts = scale.Items.filter(p => p.MinVolume == volume);

                                return (
                                    <div className="d-flex" key={volume}>
                                        <div className="flex-grow-1 text-right">
                                            {volume}+&nbsp;=&nbsp;
                                        </div>
                                        <div>
                                            {discounts.map(d => {
                                                return (
                                                    <div key={d.ApplicationTypeId}>
                                                        <i className={APPLICATION_TYPE.getOSIconClassName(d.ApplicationTypeId)}/>&nbsp;{numeral(d.DiscountPercent).format('0[.]00')}%
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {(Boolean(scale.BeginTime) || Boolean(scale.EndTime)) &&
                            <div className="border-top border-white small">
                                {Boolean(scale.BeginTime) && <div>from {moment.utc(scale.BeginTime).format('L LT (z)')}</div>}
                                {Boolean(scale.EndTime) && <div>till {moment.utc(scale.EndTime).format('L LT (z)')}</div>}
                            </div>
                        }
                    </div>
                }
            >
                <div className="discountscale">{scale.ScaleName}</div>
            </SimpleTooltip>
        )
    }
}

class DiscountScale extends ReactComponent {
    render() {
        const self = this;
        const scale = self.props.scale;

        if (!Boolean(scale)) {
            return null;
        }

        const volumes = scale.Items
            .map(p => p.MinVolume)
            .filter((p, i, a) => a.indexOf(p) == i);

        return (
            <SimpleTooltip
                isHtml
                title={
                    <div className="text-left">
                        {(scale.Items.length == 0) && <span className="text-secondary">empty</span>}
                        {(scale.Items.length > 0) &&
                            <table className="table-striped">
                                <tbody>
                                    {volumes
                                        .map(volume => {
                                            const discounts = scale.Items.filter(p => p.MinVolume == volume);

                                            return (
                                                <tr key={volume}>
                                                    <td className="text-right align-baseline">{volume}+&nbsp;=&nbsp;</td>
                                                    <td>
                                                        {discounts.map(d => {
                                                            return (
                                                                <div key={d.ApplicationTypeId}>
                                                                    <i className={APPLICATION_TYPE.getOSIconClassName(d.ApplicationTypeId)}/>&nbsp;{numeral(d.DiscountPercent).format('0[.]00')}%
                                                                </div>
                                                            )
                                                        })}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        }
                        {(Boolean(scale.BeginTime) || Boolean(scale.EndTime)) &&
                            <div className="border-top border-white small">
                                {Boolean(scale.BeginTime) && <div>from {moment.utc(scale.BeginTime).format('L LT (z)')}</div>}
                                {Boolean(scale.EndTime) && <div>till {moment.utc(scale.EndTime).format('L LT (z)')}</div>}
                            </div>
                        }
                    </div>
                }
            >
                <div className="discountscale">{scale.ScaleName}</div>
            </SimpleTooltip>
        )
    }
}

class InvoicesTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            invoices: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0
        }

        this.doLoad = this.doLoad.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const requestId = self.state.requestId + 1;

        const data = {AccountId: self.state.accountId, pn: self.state.pageNum, ps: self.state.pageSize};

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountInvoices',
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    invoices: response.Invoices,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, invoices} = self.state;
        const {timeZoneId} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        const utcNow = moment.utc();

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountinvoiceslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Paid date</th>
                            <th className="w-100">Description</th>
                            <th className="text-right">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && invoices.map(p => {
                            let rowClass = '';

                            switch (p.StateId) {
                                case INVOICE_STATE.Pending:
                                    rowClass = 'warning';
                                    break;

                                case INVOICE_STATE.Refunded:
                                    rowClass = 'danger';
                                    break;
                            }
    
                            return (
                                <tr key={p.Id} className={rowClass}>
                                    <td><Link to={UrlBuilder.InvoiceInfo({InvoiceId: p.Id, ListSource: 'account'})}>{p.Id}</Link></td>
                                    <td><DateTimeItem utcDate={p.CreatedAt} timeZoneId={timeZoneId} /></td>
                                    <td>
                                        {p.IsPaid && <DateTimeItem utcDate={p.PaidAt} timeZoneId={timeZoneId} />}
                                        {!p.IsPaid && Boolean(p.PaymentDeadLine) &&
                                            <span 
                                                className={utcNow.isAfter(p.PaymentDeadLine) > 0 ? 'text-danger' : 'text-warning'}
                                            >
                                                deadline:&nbsp;<DateTimeItem utcDate={p.PaymentDeadLine} timeZoneId={timeZoneId} />
                                            </span>
                                        }
                                    </td>
                                    <td className="w-100 text-pre-line">{p.Description}</td>
                                    <td className="text-right font-weight-bold">
                                        {(p.AffiliateCommission != 0) && !Boolean(p.AffiliateInfo) && <sup className="mre-1">{numeral(p.AffiliateCommission).USD()}</sup>}
                                        {(p.AffiliateCommission != 0) && Boolean(p.AffiliateInfo) &&
                                            <SimpleTooltip
                                                placement="right"
                                                title={`Commission to ${p.AffiliateInfo.Name}`}
                                            >
                                                <sup className="mre-1">
                                                    <Link to={p.AffiliateInfo.AdminUrl} target="_blank">{numeral(p.AffiliateCommission).USD()}</Link>
                                                </sup>
                                            </SimpleTooltip>
                                        }
                                        {numeral(p.Amount).USD()}
                                    </td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
InvoicesTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    versionStamp: PropTypes.any,
}
InvoicesTable.defaultProps = {
    pageSize: 20,
}

class PaymentsTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            paymentTypeId: null,
            paymentStateId: null,
            isLoaded: false,
            isLoading: false,
            errors: null,
            payments: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0
        }

        this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
        this.handlePaymentStateChange = this.handlePaymentStateChange.bind(this);

        this.doLoad = this.doLoad.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handlePaymentTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const paymentTypeId = isNaN(v) ? null : v;

        if (paymentTypeId != self.state.paymentTypeId) {
            self.setState({paymentTypeId: paymentTypeId}, self.doLoad);
        }
    }

    handlePaymentStateChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const paymentStateId = isNaN(v) ? null : v;

        if (paymentStateId != self.state.paymentStateId) {
            self.setState({paymentStateId: paymentStateId}, self.doLoad);
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const requestId = self.state.requestId + 1;
        const {accountId, paymentTypeId, paymentStateId} = self.state;

        const data = {AccountId: accountId, payt: paymentTypeId, pays: paymentStateId, pn: self.state.pageNum, ps: self.state.pageSize};

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountPayments',
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    payments: response.Payments,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, payments, paymentTypeId, paymentStateId} = self.state;
        const {timeZoneId, paymentTypes, paymentStates} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={paymentTypeId ?? ''}
                            onChange={self.handlePaymentTypeChange}
                            disabled={isLoading}
                        >
                            <option value={Number.MAX_SAFE_INTEGER} className="d-none">Payment type</option>
                            <option value="">any</option>
                            {paymentTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Payment type</label>
                    </div>
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={paymentStateId ?? ''}
                            onChange={self.handlePaymentStateChange}
                            disabled={isLoading}
                        >
                            <option value={Number.MAX_SAFE_INTEGER} className="d-none">Payment state</option>
                            <option value="">any</option>
                            {paymentStates.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Payment state</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountpaymentslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Transaction #</th>
                            <th className="w-100">Description</th>
                            <th className="text-right">Amount</th>
                            <th className="text-right">Fee</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && payments.map(p => {
                            let rowClass = '';

                            switch (p.StateId) {
                                case PAYMENT_STATE.Pending:
                                    rowClass = 'warning';
                                    break;
                                case PAYMENT_STATE.Error:
                                    rowClass = 'danger';
                                    break;
                            }
        
                            return (
                                <tr key={p.Id} className={rowClass}>
                                    <td>
                                        <Link to={UrlBuilder.PaymentInfo({PaymentId: p.Id, ListSource: 'account'})}>{p.Id}</Link>
                                        {Boolean(p.IsAuto) && <span className="text-warning">(auto)</span>}
                                    </td>
                                    <td><DateTimeItem utcDate={p.CreatedAt} timeZoneId={timeZoneId} /></td>
                                    <td>{p.TransactionId}</td>
                                    <td className="w-100 text-pre-line">{p.Description}</td>
                                    <td className={'text-right font-weight-bold' + (p.Amount < 0 ? ' text-danger' : '')}>
                                        {numeral(p.Amount).USD()}
                                    </td>
                                    <td className="text-right">
                                        {(p.Fee != null) && numeral(p.Fee).USD()}
                                    </td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
PaymentsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    paymentTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    paymentStates: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
PaymentsTable.defaultProps = {
    pageSize: 20,
}

class MailsTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            mails: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
            mailTypeId: null,
            isSuccess: null
        }

        this.doLoad = this.doLoad.bind(this);
        this.handleMailTypeChange = this.handleMailTypeChange.bind(this);
        this.handleIsSuccessChange = this.handleIsSuccessChange.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handleMailTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const mailTypeId = isNaN(v) ? null : v;

        if (mailTypeId != self.state.mailTypeId) {
            self.setState({mailTypeId: mailTypeId}, self.doLoad);
        }
    }

    handleIsSuccessChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const isSuccess = isNaN(v) ? null : v;

        if (isSuccess != self.state.isSuccess) {
            self.setState({isSuccess: isSuccess}, self.doLoad);
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const requestId = self.state.requestId + 1;

        const data = {
            AccountId: self.state.accountId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
            mt: self.state.mailTypeId, 
            s: (self.state.isSuccess == null) ? null : self.state.isSuccess != 0
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountMails',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    mails: response.Mails,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, mails, mailTypeId, isSuccess} = self.state;
        const {timeZoneId, mailTypes} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={mailTypeId ?? ''}
                            onChange={self.handleMailTypeChange}
                            disabled={isLoading}
                        >
                            <option value="">any</option>
                            {mailTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Mail type</label>
                    </div>
                    <div className="form-group newstyle">
                        <select
                            className="custom-select w-auto"
                            value={isSuccess ?? ''}
                            onChange={self.handleIsSuccessChange}
                            disabled={isLoading}
                        >
                            <option value="">any</option>
                            <option value="1">Succeded</option>
                            <option value="0">Failed</option>
                        </select>
                        <label>Status</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountmailslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Address</th>
                            <th className="w-100">Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && mails.map(p => {
                            let rowClass = p.IsSuccess ? '' : 'danger';

                            return (
                                <tr key={p.Id} className={rowClass}>
                                    <td className="text-right"><Link to={UrlBuilder.MailInfo({MailId: p.Id, ListSource: 'account'})}>{p.Id}</Link></td>
                                    <td><DateTimeItem utcDate={p.TimeStamp} timeZoneId={timeZoneId} format="L LTS (z)" /></td>
                                    <td>{p.MailTypeName}</td>
                                    <td>{p.MailAddress}</td>
                                    <td className="w-100"><div className="verticaloverflow height-3 observe-resize">{p.ErrorMessage}</div></td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
MailsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    mailTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
MailsTable.defaultProps = {
    pageSize: 20,
}

class EventsTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            events: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
            eventTypeId: null,
        }

        this.doLoad = this.doLoad.bind(this);
        this.handleEventTypeChange = this.handleEventTypeChange.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handleEventTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const eventTypeId = isNaN(v) ? null : v;

        if (eventTypeId != self.state.eventTypeId) {
            self.setState({eventTypeId: eventTypeId}, self.doLoad);
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {
            AccountId: self.state.accountId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
            et: self.state.eventTypeId, 
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountEvents',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    events: response.Events,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, events, eventTypeId} = self.state;
        const {timeZoneId, eventTypes} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={eventTypeId ?? ''}
                            onChange={self.handleEventTypeChange}
                            disabled={isLoading}
                        >
                            <option value="">any</option>
                            {eventTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Event type</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accounteventslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Extended Id</th>
                            <th className="w-100">Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && events.map(p => {
                            return (
                                <tr key={p.Id}>
                                    <td className="text-right">{p.Id}</td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.CreatedAt} timeZoneId={timeZoneId} format="L LTS (z)" /></td>
                                    <td>{p.EventTypeName}</td>
                                    <td>{p.ExtendedId}</td>
                                    <td className="w-100"><div className="verticaloverflow height-3 observe-resize">{p.Message}</div></td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
EventsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    eventTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
EventsTable.defaultProps = {
    pageSize: 20,
}

class PopupMessagesTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            popupMessages: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
            popupMessageTypeId: null,
        }

        this.doLoad = this.doLoad.bind(this);
        this.handlePopupMessageTypeChange = this.handlePopupMessageTypeChange.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handlePopupMessageTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const popupMessageTypeId = isNaN(v) ? null : v;

        if (popupMessageTypeId != self.state.popupMessageTypeId) {
            self.setState({popupMessageTypeId: popupMessageTypeId}, self.doLoad);
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {
            AccountId: self.state.accountId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
            mt: self.state.popupMessageTypeId, 
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountPopupMessages',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    popupMessages: response.PopupMessages,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, popupMessages, popupMessageTypeId} = self.state;
        const {timeZoneId, popupMessageTypes} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={popupMessageTypeId ?? ''}
                            onChange={self.handlePopupMessageTypeChange}
                            disabled={isLoading}
                        >
                            <option value={Number.MAX_SAFE_INTEGER} className="d-none">Popup message type</option>
                            <option value="">any</option>
                            {popupMessageTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Popup message type</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountpopupmessageslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Closed</th>
                            <th>Type</th>
                            <th>Extended Id</th>
                            <th className="w-100">Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && popupMessages.map(p => {
                            return (
                                <tr key={p.Id}>
                                    <td className="text-right">{p.Id}</td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.CreatedAt} timeZoneId={timeZoneId} /></td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.ClosedAt} timeZoneId={timeZoneId} /></td>
                                    <td className="text-nowrap">{p.PopupMessageTypeName}</td>
                                    <td>{p.ExtendedId}</td>
                                    <td className="w-100">
                                        <div className="verticaloverflow height-3 observe-resize" dangerouslySetInnerHTML={{__html: p.Message}} />
                                    </td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
PopupMessagesTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    popupMessageTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
PopupMessagesTable.defaultProps = {
    pageSize: 20,
}

class AgentsTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            agents: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
            applicationTypeId: null,
            deletedStateId: 0, // not deleted
        }

        this.doLoad = this.doLoad.bind(this);
        this.handleApplicationTypeChange = this.handleApplicationTypeChange.bind(this);
        this.handleDeletedStateChange = this.handleDeletedStateChange.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handleApplicationTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const applicationTypeId = isNaN(v) ? null : v;

        if (applicationTypeId != self.state.applicationTypeId) {
            self.setState({applicationTypeId: applicationTypeId}, self.doLoad);
        }
    }

    handleDeletedStateChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const deletedStateId = isNaN(v) ? null : v;

        if (deletedStateId != self.state.deletedStateId) {
            self.setState({deletedStateId: deletedStateId}, self.doLoad);
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {
            AccountId: self.state.accountId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
            at: self.state.applicationTypeId, 
            ds: self.state.deletedStateId,
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountAgents',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    agents: response.Agents,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, agents, applicationTypeId, deletedStateId} = self.state;
        const {timeZoneId, applicationTypes, deletedStates} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={applicationTypeId ?? ''}
                            onChange={self.handleApplicationTypeChange}
                            disabled={isLoading}
                        >
                            <option value={Number.MAX_SAFE_INTEGER} className="d-none">Application type</option>
                            <option value="">any</option>
                            {applicationTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Application type</label>
                    </div>
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={deletedStateId ?? ''}
                            onChange={self.handleDeletedStateChange}
                            disabled={isLoading}
                        >
                            <option value="">any</option>
                            {deletedStates.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Deleted state</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountagentslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Created</th>
                            <th>Deleted</th>
                            <th>Type</th>
                            <th>Version</th>
                            <th>DBMSs</th>
                            <th>Jobs</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && agents.map(p => {
                            let rowClass = '';

                            if (Boolean(p.DeletedAt)) {
                                rowClass = 'danger';
                            }
                            else if (!Boolean(p.IsActive)) {
                                rowClass = 'secondary';
                            }
                            const operationSystemIcon = APPLICATION_TYPE.getOSIconClassName(p.ApplicationTypeId);

                            return (
                                <tr key={p.Id} className={rowClass}>
                                    <td className="text-right">
                                        <Link to={UrlBuilder.AgentInfo({AgentId: p.Id, ListSource: 'account'})}>{p.Id}</Link>
                                        {p.IsOnline &&
                                            <small className="text-success ml-1">on</small>
                                        }
                                        {!p.IsOnline &&
                                            <small className="text-danger ml-1">off</small>
                                        }
                                    </td>
                                    <td className="w-100 text-break-word">{p.Name}</td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.CreatedAt} timeZoneId={timeZoneId} /></td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.DeletedAt} timeZoneId={timeZoneId} /></td>
                                    <td className="text-nowrap"><i className={"mre-1 " + operationSystemIcon} />{p.ApplicationTypeName}</td>
                                    <td className="text-nowrap">{p.Version}</td>
                                    <td className="text-right">{p.ConnectionsCount}</td>
                                    <td className="text-right">{p.JobsCount}</td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
AgentsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    applicationTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
AgentsTable.defaultProps = {
    pageSize: 20,
}

class DestinationsTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            destinations: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
            destinationTypeId: null,
            deletedStateId: 0, // not deleted
            usageStateId: 0, // used only
        }

        this.doLoad = this.doLoad.bind(this);
        this.handleDestinationTypeChange = this.handleDestinationTypeChange.bind(this);
        this.handleDeletedStateChange = this.handleDeletedStateChange.bind(this);
        this.handleUsageStateChange = this.handleUsageStateChange.bind(this);
        this.getDestinationSettings = this.getDestinationSettings.bind(this);
        this.getDestinationAccessSettings = this.getDestinationAccessSettings.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handleDestinationTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const destinationTypeId = isNaN(v) ? null : v;

        if (destinationTypeId != self.state.destinationTypeId) {
            self.setState({destinationTypeId: destinationTypeId}, self.doLoad);
        }
    }

    handleDeletedStateChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const deletedStateId = isNaN(v) ? null : v;

        if (deletedStateId != self.state.deletedStateId) {
            self.setState({deletedStateId: deletedStateId}, self.doLoad);
        }
    }

    handleUsageStateChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const usageStateId = isNaN(v) ? null : v;

        if (usageStateId != self.state.usageStateId) {
            self.setState({usageStateId: usageStateId}, self.doLoad);
        }
    }

    getDestinationSettings(destinationId) {
        const self = this;

        if (self._isMounted && self.state.isLoaded) {
            const destination = self.state.destinations.find(p => p.Id == destinationId);

            if (destination != null) {

                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getDestinationSettings',
                            data: {id: destinationId},
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted
                )
                .then(requestResult => {
                    if (self._isMounted) {
                        return `<div class="textualinfo">${requestResult}</div>`;
                    }
                });
            }
        }

        return null;
    }

    getDestinationAccessSettings(destinationId) {
        const self = this;

        if (self._isMounted && self.state.isLoaded) {
            const destination = self.state.destinations.find(p => p.Id == destinationId);

            if (destination != null) {

                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getDestinationAccessSettings',
                            data: {id: destinationId},
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted
                )
                .then(requestResult => {
                    if (self._isMounted) {
                        return `<div class="textualinfo">${requestResult}</div>`;
                    }
                });
            }
        }

        return null;
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {
            AccountId: self.state.accountId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
            dt: self.state.destinationTypeId, 
            ds: self.state.deletedStateId,
            us: self.state.usageStateId,
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountDestinations',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    destinations: response.Destinations,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, destinations, destinationTypeId, deletedStateId, usageStateId} = self.state;
        const {timeZoneId, destinationTypes, deletedStates, usageStates} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));
        const showAgent = destinations.some(p => Boolean(p.AgentId));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={destinationTypeId ?? ''}
                            onChange={self.handleDestinationTypeChange}
                            disabled={isLoading}
                        >
                            <option value={Number.MAX_SAFE_INTEGER} className="d-none">Destination type</option>
                            <option value="">any</option>
                            {destinationTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Destination type</label>
                    </div>
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={deletedStateId ?? ''}
                            onChange={self.handleDeletedStateChange}
                            disabled={isLoading}
                        >
                            <option value="">any</option>
                            {deletedStates.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Deleted state</label>
                    </div>
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={usageStateId ?? ''}
                            onChange={self.handleUsageStateChange}
                            disabled={isLoading}
                        >
                            <option value="">any</option>
                            {usageStates.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Usage state</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountdestinationslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            {showAgent && <th>Exclusive for agent</th>}
                            <th>Deleted</th>
                            <th colSpan={2}>Type</th>
                            <th>Jobs</th>
                            <th>Information</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && destinations.map(p => {
                            let rowClass = '';

                            if (Boolean(p.DeletedAt)) {
                                rowClass = 'danger';
                            }
                            
                            return (
                                <tr key={p.Id} className={rowClass}>
                                    {/* <td className="text-right"><Link to={UrlBuilder.AgentInfo({AgentId: p.Id, ListSource: 'account'})}>{p.Id}</Link></td> */}
                                    <td width="1%" className="text-right">{p.Id}</td>
                                    <td className="w-50 text-break-word">{p.Name}</td>
                                    {showAgent &&
                                        <td className="w-50 text-break-word">
                                            <Link to={UrlBuilder.AgentInfo({AgentId: p.AgentId, ListSource: 'account'})} className="mr-2">{p.AgentId}</Link>
                                            {p.AgentName}
                                        </td>
                                    }
                                    <td width="1%" className="text-nowrap"><DateTimeItem utcDate={p.DeletedAt} timeZoneId={timeZoneId} /></td>
                                    <td className="text-right pr-0"><i className={p.DestinationTypeIconClassName}/></td>
                                    <td className="text-nowrap">{p.DestinationTypeName}</td>
                                    <td width="1%" className="text-right">{p.JobsCount}</td>
                                    <td width="1%" className="text-nowrap fs-sm">
                                        <div>
                                            <ItemPopupDescriptionComponent
                                                popoverClassName="popover-white"
                                                placement="bottom"
                                                text={() => self.getDestinationSettings(p.Id)}
                                                showCopyButton
                                                showIfEmpty
                                            >
                                                Settings
                                            </ItemPopupDescriptionComponent>
                                        </div>
                                        <div>
                                            <ItemPopupDescriptionComponent
                                                popoverClassName="popover-white"
                                                placement="bottom"
                                                text={() => self.getDestinationAccessSettings(p.Id)}
                                                showCopyButton
                                                showIfEmpty
                                            >
                                                Access settings
                                            </ItemPopupDescriptionComponent>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
DestinationsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    destinationTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    deletedStates: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    usageStates: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
DestinationsTable.defaultProps = {
    pageSize: 20,
}

class SubscriptionsTable extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            subscriptions: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
            servicePlanTypeId: null,
        }

        this.doLoad = this.doLoad.bind(this);
        this.handleServicePlanTypeChange = this.handleServicePlanTypeChange.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.accountId != prevProps.accountId) {
            self.setState({accountId: self.props.accountId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    handleServicePlanTypeChange(e) {
        const self = this;
        const v = parseInt(e.target.value);
        const servicePlanTypeId = isNaN(v) ? null : v;

        if (servicePlanTypeId != self.state.servicePlanTypeId) {
            self.setState({servicePlanTypeId: servicePlanTypeId}, self.doLoad);
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {
            AccountId: self.state.accountId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
            pt: self.state.servicePlanTypeId, 
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountSubscriptions',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    subscriptions: response.Subscriptions,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, subscriptions, servicePlanTypeId} = self.state;
        const {timeZoneId, servicePlanTypes} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="d-flex">
                    <div className="form-group newstyle mr-2">
                        <select
                            className="custom-select w-auto"
                            value={servicePlanTypeId ?? ''}
                            onChange={self.handleServicePlanTypeChange}
                            disabled={isLoading}
                        >
                            <option value={Number.MAX_SAFE_INTEGER} className="d-none">Service plan</option>
                            <option value="">any</option>
                            {servicePlanTypes.map(p => <option key={`mt-${p.Id}`} value={p.Id}>{p.Name}</option>)}
                        </select>
                        <label>Service plan</label>
                    </div>
                </div>
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="accountsubscriptionslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Started</th>
                            <th>Finished</th>
                            <th>Duration</th>
                            <th>Service plan</th>
                            <th>Payment plan</th>
                            <th>Invoice#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && subscriptions.map(p => {
                            let rowClass = undefined;
                            
                            if (p.IsTrial) {
                                rowClass = (rowClass || '') + ' success';
                            }
                            if (!p.IsFinished) {
                                rowClass = (rowClass || '') + ' font-weight-semibold'
                            }

                            return (
                                <tr key={p.Id} className={rowClass}>
                                    <td className="text-right">{p.Id}</td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.StartedAt} timeZoneId={timeZoneId} /></td>
                                    {p.IsFinished &&
                                        <>
                                            <td className="text-nowrap"><DateTimeItem utcDate={p.FinishedAt} timeZoneId={timeZoneId} /></td>
                                            <td className="text-nowrap"><DurationComponent startedAt={p.StartedAt} finishedAt={p.FinishedAt} /></td>
                                        </>
                                    }
                                    {!p.IsFinished &&
                                        <>
                                            <td className="text-nowrap font-italic ico-muted"><DateTimeItem utcDate={p.FinishedAt} timeZoneId={timeZoneId} /></td>
                                            <td className="text-nowrap"><DurationComponent startedAt={p.StartedAt} /></td>
                                        </>
                                    }
                                    <td className="text-nowrap">{p.ServicePlanTypeName}</td>
                                    <td className="text-nowrap">{p.PaymentPlanName}</td>
                                    <td className="text-nowrap">
                                        {Boolean(p.InvoiceId) &&
                                            <Link
                                                to={UrlBuilder.InvoiceInfo({InvoiceId: p.InvoiceId, ListSource: 'account'})}
                                            >
                                                {p.InvoiceId}
                                            </Link>
                                        }
                                    </td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
SubscriptionsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    servicePlanTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
SubscriptionsTable.defaultProps = {
    pageSize: 20,
}

export class AccountInfoComponent extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            accountId: props.accountId,
            action: ACCOUNTINFO_ACTION.NONE,
            isLoaded: false,
            errors: null,
            accountInfo: null,
            requestId: 0,
            versionStamp: {}
        }

        this.doLoad = this.doLoad.bind(this);
        this.doSaveNotes = this.doSaveNotes.bind(this);
        this.handleRefreshClick = this.handleRefreshClick.bind(this);
        this.handleEditNotesDialogHide = this.handleEditNotesDialogHide.bind(this);
        this.handleEditNotesClick = this.handleEditNotesClick.bind(this);
        this.goToAccountId = this.goToAccountId.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }

        const requestId = self.state.requestId + 1;

        const data = {AccountId: self.state.accountId};

        new Promise(resolve => {
            self.setState({action: ACCOUNTINFO_ACTION.LOADING, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAccountInfo',
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                );
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    action: ACCOUNTINFO_ACTION.NONE,
                    isLoaded: true,
                    accountInfo: response,
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({action: ACCOUNTINFO_ACTION.NONE, errors: errors})
            }
        });
    }

    handleRefreshClick() {
        const self = this;

        self.setState({versionStamp: new Date() * 1}, self.doLoad);
    }

    goToAccountId(accountId) {
        const self = this;

        if (self._isMounted) {
            ReplaceUrl(UrlBuilder.AccountInfo({AccountId: accountId, ListSource: self.props.listSource}));
    
            self.setState({accountId: accountId}, self.doLoad);
        }
    }

    doSaveNotes(notes) {
        const self = this;
        const data = {AccountId: self.state.accountId, Notes: notes};
        const verificationToken = self.state.accountInfo.VerificationToken;

        const result = MakeApiCall(
            $.post(
                {
                    url: '/api/admin/saveAccountNotes',
                    headers: {RequestVerificationToken: verificationToken},
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    dataType: 'json',
                    cache: false
                }
            )
        )
        .then(response => {
            if (self._isMounted) {
                const accountInfo = {...self.state.accountInfo, AdminNotes: notes};
                self.setState({accountInfo: accountInfo});
            }

            return response;
        });

        return result;
    }

    handleEditNotesClick() {
        this.setState({action: ACCOUNTINFO_ACTION.EDITNOTES});
    }

    handleEditNotesDialogHide() {
        const self = this;

        if (self.state.action == ACCOUNTINFO_ACTION.EDITNOTES) {
            self.setState({action: ACCOUNTINFO_ACTION.NONE});
        }
    }

    render() {
        const self = this;
        const {accountId, accountInfo, action, isLoaded, errors, versionStamp} = self.state;
        const {timeZoneId, applicationTypes, servicePlanTypes, deletedStates, usageStates, mailTypes, eventTypes, popupMessageTypes, destinationTypes, paymentTypes, paymentStates} = self.props;

        const utcNow = moment.utc();
        const affiliateExpireAt = isLoaded
            ? moment.utc(accountInfo.CreatedAt).add(1, 'years')
            : null;

        const subscription = isLoaded ? accountInfo.Subscription : null;
        const isDisabled = !isLoaded || (action != ACCOUNTINFO_ACTION.NONE);

        let subscriptionInfo = null;
        const agentCounts = isLoaded
            ? accountInfo.AgentCounts.filter(p => (p.OwnAgentsCount + p.SharedAgentsCount) > 0)
            : [];

        const ownAgentsCount = agentCounts.reduce((a, p) => a + p.OwnAgentsCount, 0);
        const sharedAgentsCount = agentCounts.reduce((a, p) => a + p.SharedAgentsCount, 0);

        if (Boolean(subscription)) {
            subscriptionInfo = 
                <span>
                    {subscription.ServicePlanName}
                    {subscription.IsTrial && ' trial'}
                    {(subscription.ServicePlanTypeId > 1) && ' till '}
                    {(subscription.ServicePlanTypeId > 1) && <DateTimeItem utcDate={subscription.RestartAt} timeZoneId={timeZoneId} format="L LT (z)" />}
                    {(subscription.ServicePlanTypeId > 1) && `, ${numeral(subscription.BasePrice).USD()}`}
                    {(subscription.IsPrepaid) && <span className="mr-3">{`, upto ${subscription.MaxAgents} servers`}</span>}
                    {(subscription.IsPrepaid) && !Boolean(accountInfo.SuspendedAt) && <a href={`/admin/addaccountagentlimit/${accountInfo.Id}`}>Increase limit</a>}
                </span>
        }

        const buttonPrev = Boolean(accountInfo) &&
            <Link 
                key="buttonPrev"
                className="btn btn-outline-secondary btn-sm newstyle" 
                disabled={!Boolean(accountInfo.PrevId)} 
                to={() => self.goToAccountId(accountInfo.PrevId)}
            >
                Prev
            </Link>

        const buttonNext = Boolean(accountInfo) &&
            <Link 
                key="buttonNext"
                className="btn btn-outline-secondary btn-sm newstyle" 
                disabled={!Boolean(accountInfo.NextId)} 
                to={() => self.goToAccountId(accountInfo.NextId)}
            >
                Next
            </Link>

        return (
            <div>
                <PageHeader
                    fixed
                    captionTruncate
                    notWrappedMaxHeight={75}
                    caption={
                        <h2 className="d-flex">
                            <span className="mr-2">Account #{accountId}</span>
                            {Boolean(accountInfo) && (accountInfo.Id == accountId) &&
                                <AccountComponent className="mr-2" id={accountInfo.Id} name={accountInfo.Name} showLoginAs />
                            }
                            <RefreshButtonComponent 
                                disabled={action == ACCOUNTINFO_ACTION.LOADING} 
                                animated={action == ACCOUNTINFO_ACTION.LOADING} 
                                onClick={self.handleRefreshClick} 
                                className="fs-085"
                            />
                        </h2>
                    }
                    buttons={[<div key="buttonGroup" className="btn-group">{[buttonPrev, buttonNext].filter(Boolean)}</div>]}
                />
                <ErrorsBlockComponent errors={errors} />
                {isLoaded && (action == ACCOUNTINFO_ACTION.EDITNOTES) &&
                    <EditNotesDialogComponent
                        title={<span className="fs-125"><span className="mr-1 fa fa-edit" />Notes for account #{accountInfo.Id}</span>}
                        notes={accountInfo.AdminNotes}
                        doSave={self.doSaveNotes}
                        onHide={self.handleEditNotesDialogHide}
                    />
                }
                {isLoaded &&
                    <div>
                        <InfoItem caption="Global Id" content={accountInfo.GlobalId} />
                        {Boolean(accountInfo.StripeCustomerId) &&
                            <InfoItem 
                                caption="Stripe CustomerId" 
                                content={<a href={`https://dashboard.stripe.com/customers/${accountInfo.StripeCustomerId}`} target="_blank">{accountInfo.StripeCustomerId}</a>} 
                            />
                        }
                        <InfoItem 
                            caption="Email" 
                            content={
                                <div>
                                    <span className="mr-2">{accountInfo.Email}</span>
                                    <EmailBlackListStatusComponent 
                                        className="mr-2" 
                                        statusData={accountInfo.BlackListStatuses.find(p => p.MailAddress.toUpperCase() == accountInfo.Email.toUpperCase())} 
                                    />
                                    {Boolean(accountInfo.SocialAccounts) && 
                                        accountInfo.SocialAccounts.map(p => {
                                            return (
                                                <SimpleTooltip key={p.Id} title={p.DisplayName} placement="right">
                                                    <span className={p.IconClassName + ' mre-1'}/>
                                                </SimpleTooltip>
                                            )
                                        })
                                    }
                                </div>
                            } 
                        />
                        {(accountInfo.Emails.length > 1) &&
                            <InfoItem 
                                caption="Other emails" 
                                content={
                                    <div className="d-flex flex-wrap">
                                        {accountInfo.Emails
                                            .filter(p => p.toUpperCase() != accountInfo.Email.toUpperCase())
                                            .map((email, i, a) => {
                                                return (
                                                    <div key={email} className="mr-2 text-nowrap">
                                                        <span>{email}</span>
                                                        <EmailBlackListStatusComponent className="ml-2" statusData={accountInfo.BlackListStatuses.find(p => p.MailAddress.toUpperCase() == email.toUpperCase())} />
                                                        {(i == a.length - 1) ? '' : ','}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                } 
                            />
                        }
                        <InfoItem caption="Role" content={accountInfo.RoleName} />
                        <InfoItem caption="Company" content={accountInfo.Company} />
                        <InfoItem 
                            caption="Country" 
                            content={Boolean(accountInfo.CountryId) &&
                                <span>
                                    <span className={`mre-1 flag flag-${accountInfo.CountryId.toLowerCase()}`}></span>
                                    <span>{`${accountInfo.CountryId} ${accountInfo.CountryName}`}</span>
                                </span>
                            }
                        />
                        {Boolean(accountInfo.SubdivisionId) &&
                            <InfoItem caption="State/Province" content={`${accountInfo.SubdivisionId} ${accountInfo.SubdivisionName}`} />
                        }
                        <InfoItem caption="Address" content={accountInfo.Address} />
                        <InfoItem 
                            caption="Time Zone" 
                            content={Boolean(accountInfo.TimeZoneId) && GetMomentTimeZoneName(accountInfo.TimeZoneId, GetMomentTimeZoneName.FLAG_ADD_UTCOFFSET, accountInfo.TimeZoneName)}
                        />
                        <InfoItem caption="Created" content={<DateTimeItem utcDate={accountInfo.CreatedAt} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        {Boolean(accountInfo.DeletedAt) &&
                            <InfoItem caption="Deleted" content={<DateTimeItem className="text-danger" utcDate={accountInfo.DeletedAt} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        }
                        {!Boolean(accountInfo.DeletedAt) && Boolean(accountInfo.LockedAt) &&
                            <InfoItem caption="Locked" content={<DateTimeItem className="text-danger" utcDate={accountInfo.LockedAt} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        }
                        {!Boolean(accountInfo.DeletedAt) && !Boolean(accountInfo.LockedAt) && Boolean(accountInfo.SuspendedAt) &&
                            <InfoItem caption="Suspended" content={<DateTimeItem className="text-warning" utcDate={accountInfo.SuspendedAt} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        }
                        <InfoItem caption="Update channel" content={accountInfo.UpdateChannelName} />
                        <InfoItem caption="Last visit" content={Boolean(accountInfo.LastVisitAt) && <DateTimeItem utcDate={accountInfo.LastVisitAt} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        <InfoItem caption="Last visit IP" content={accountInfo.LastIP} />
                        <InfoItem 
                            caption="Last visit Country" 
                            content={Boolean(accountInfo.LastCountryId) &&
                                <span>
                                    <span className={'' + `mre-1 flag flag-${accountInfo.LastCountryId.toLowerCase()}`}></span>
                                    <span>{`${accountInfo.LastCountryId} ${accountInfo.LastCountryName}`}</span>
                                </span>
                            }
                        />
                        {Boolean(accountInfo.LastSubdivisionId) &&
                            <InfoItem caption="Last visit State/Province" content={`${accountInfo.LastSubdivisionId} ${accountInfo.LastSubdivisionName}`} />
                        }
                        {Boolean(accountInfo.AffiliateInfo) &&
                            <InfoItem 
                                caption="Affiliate" 
                                content={
                                    <div className="text-nowrap">
                                        <Link to={accountInfo.AffiliateInfo.AdminUrl} target="_blank" className="mr-2">#{accountInfo.AffiliateInfo.Id}</Link>
                                        <span className="mr-2">{accountInfo.AffiliateInfo.Name}</span>
                                        <span className="small text-secondary">
                                            ({(affiliateExpireAt.isAfter(utcNow) ? 'reference expires' : 'reference expired')} {affiliateExpireAt.format('L LT (UTC)')})
                                        </span>
                                    </div>
                                } 
                            />
                        }

                        <InfoItem 
                            vertical
                            caption="Notes" 
                            content={
                                <textarea
                                    className="form-control compact text-body bg-white"
                                    readOnly
                                    value={accountInfo.AdminNotes || ''}
                                />
                            }
                        />
                        <div className="pt-4">
                            <button 
                                type="button"
                                className="btn btn-outline-primary btn-sm newstyle"
                                disabled={isDisabled}
                                onClick={self.handleEditNotesClick}
                            >
                                <span className="mr-1 fa fa-edit" />Edit notes
                            </button>
                        </div>

                        <h4 className="pt-3">Billing</h4>
                        <InfoItem caption="Total paid" content={<b>{numeral(accountInfo.TotalPaid).USD()}</b>} />
                        <InfoItem 
                            caption={accountInfo.Balance >= 0 ? 'Credit' : 'Balance'} 
                            content={
                                <>
                                    <span className={'font-weight-bold mr-3 ' + (accountInfo.Balance >= 0 ? 'text-success' : 'text-danger')}>
                                        {numeral(Math.abs(accountInfo.Balance)).USD()}
                                    </span>
                                    <a href={`/admin/addaccountpayment/${accountInfo.Id}`}>Add payment</a>
                                </>
                            }
                        />
                        {Boolean(accountInfo.CreditCard) &&
                            <InfoItem
                                caption="Credit card"
                                content={
                                    <CreditCardCaptionComponent 
                                        cardNumber={accountInfo.CreditCard.ShortDisplayNumber} 
                                        cardBrandName={accountInfo.CreditCard.BrandName} 
                                        showIcon
                                        showBrand
                                        showNumber
                                    />
                                }
                            />
                        }
                        <InfoItem 
                            caption="Servers" 
                            content={
                                <>
                                    {agentCounts.map((p, i) => {
                                        return (
                                            <span key={p.ApplicationTypeId}>
                                                {(i > 0) && <span>&nbsp;+&nbsp;</span>}
                                                <i className={APPLICATION_TYPE.getOSIconClassName(p.ApplicationTypeId)} />&nbsp;{p.OwnAgentsCount + p.SharedAgentsCount}
                                                {(p.SharedAgentsCount > 0) && 
                                                    <sub>({p.OwnAgentsCount}&nbsp;+&nbsp;{p.SharedAgentsCount})</sub>
                                                }
                                            </span>
                                        )
                                    })}
                                    {(agentCounts.length == 0) && <span>0</span>}
                                    {(agentCounts.length > 1) &&
                                        <>
                                            <span>&nbsp;=&nbsp;{ownAgentsCount + sharedAgentsCount}</span>
                                            {(sharedAgentsCount > 0) &&
                                                <sub>({ownAgentsCount}&nbsp;+&nbsp;{sharedAgentsCount})</sub>
                                            }
                                        </>
                                    }
                                </>
                            }
                        />
                        <InfoItem 
                            caption="Jobs" 
                            content={
                                (accountInfo.SharedJobsCount > 0)
                                    ? `${accountInfo.OwnJobsCount} + ${accountInfo.SharedJobsCount} = ${accountInfo.OwnJobsCount + accountInfo.SharedJobsCount}`
                                    : accountInfo.OwnJobsCount + ''
                            }
                        />
                        <InfoItem caption="Service plan" content={subscriptionInfo} />
                        {Boolean(subscription) && Boolean(subscription.PaymentPlanName) &&
                            <InfoItem caption="Payment plan" content={subscription.PaymentPlanName} />
                        }
                        <InfoItem
                            caption="Discount scale(s)"
                            content={
                                <div className="d-flex">
                                    {accountInfo.DiscountScales.map(p => <DiscountScale key={p.Id || 'default'} scale={p} />)}
                                    {(accountInfo.DiscountScales.length > 1) &&
                                        <DiscountScale 
                                            scale={{
                                                ScaleName: <b>Σ</b>, 
                                                Items: accountInfo.DiscountScale
                                            }} 
                                        />
                                    }
                                </div>
                            }
                        />
                        {(accountInfo.SummaryDiscountPercents.length > 0) &&
                            <InfoItem 
                                caption="Summary discount percent" 
                                content={
                                    <div>
                                        {(accountInfo.SummaryDiscountPercents.length == 1) &&
                                            `${numeral(accountInfo.SummaryDiscountPercents[0].Value).format('0[.]00')}%`
                                        }
                                        {(accountInfo.SummaryDiscountPercents.length != 1) && accountInfo.SummaryDiscountPercents.map(p => {
                                            return(
                                                <div key={p.Key}>
                                                    <i className={APPLICATION_TYPE.getOSIconClassName(p.Key)} />&nbsp;{`${numeral(p.Value).format('0[.]00')}%`}
                                                </div>
                                            )
                                        })}
                                    </div>
                                } 
                            />
                        }
                    </div>
                }
                {isLoaded &&
                    <div className="pt-3">
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                                <Link className="nav-link active" data-toggle="tab" to="#invoices">
                                    Invoices
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#payments">
                                    Payments
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#subscriptions">
                                    Subscriptions
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#agents">
                                    Agents
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#destinations">
                                    Destinations
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#mails">
                                    Mails
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#events">
                                    Events
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" data-toggle="tab" to="#popupmessages">
                                    Popup messages
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div id="invoices" className="container tab-pane active p-0">
                                <InvoicesTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    versionStamp={versionStamp}
                                />
                            </div>
                            <div id="payments" className="container tab-pane p-0">
                                <PaymentsTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    versionStamp={versionStamp}
                                    paymentTypes={paymentTypes}
                                    paymentStates={paymentStates}
                                />
                            </div>
                            <div id="subscriptions" className="container tab-pane p-0">
                                <SubscriptionsTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    versionStamp={versionStamp}
                                    servicePlanTypes={servicePlanTypes}
                                />
                            </div>
                            <div id="agents" className="container tab-pane p-0">
                                <AgentsTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    versionStamp={versionStamp}
                                    applicationTypes={applicationTypes}
                                    deletedStates={deletedStates}
                                />
                            </div>
                            <div id="destinations" className="container tab-pane p-0">
                                <DestinationsTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    versionStamp={versionStamp}
                                    destinationTypes={destinationTypes}
                                    deletedStates={deletedStates}
                                    usageStates={usageStates}
                                />
                            </div>
                            <div id="mails" className="container tab-pane p-0">
                                <MailsTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    mailTypes={mailTypes}
                                    versionStamp={versionStamp}
                                />
                            </div>
                            <div id="events" className="container tab-pane p-0">
                                <EventsTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    eventTypes={eventTypes}
                                    versionStamp={versionStamp}
                                />
                            </div>
                            <div id="popupmessages" className="container tab-pane p-0">
                                <PopupMessagesTable 
                                    accountId={accountInfo.Id}
                                    timeZoneId={timeZoneId}
                                    popupMessageTypes={popupMessageTypes}
                                    versionStamp={versionStamp}
                                />
                            </div>
                        </div>

                    </div>
                }
            </div>
        )
    }
}
AccountInfoComponent.propTypes = {
    accountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    timeZoneId: PropTypes.string.isRequired,
    applicationTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    mailTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    eventTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    popupMessageTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    deletedStates: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    destinationTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    usageStates: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    servicePlanTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    paymentTypes: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
    paymentStates: PropTypes.arrayOf(PropTypes.shape({Id: PropTypes.number.isRequired, Name: PropTypes.string.isRequired})).isRequired,
}
